import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';
import './ProjectDetail.css';

interface Road {
  id: number;
  name: string;
}

interface ProjectDetailProps {
  projectId: number;
  onSelectRoad: (roadId: number, roadName: string) => void;
}

const ProjectDetail: React.FC<ProjectDetailProps> = ({ projectId, onSelectRoad }) => {
  const [project, setProject] = useState<any>(null);
  const [roads, setRoads] = useState<Road[]>([]);
  const [showAddRoad, setShowAddRoad] = useState(false);
  const [newRoadName, setNewRoadName] = useState('');

  useEffect(() => {
    loadProject();
    loadRoads();
  }, [projectId]);

  const loadProject = async () => {
    try {
      const response = await fetch(`${API_URL}/projects/${projectId}`);
      const data = await response.json();
      setProject(data);
    } catch (error) {
      console.error('Error loading project:', error);
    }
  };

  const loadRoads = async () => {
    try {
      const response = await fetch(`${API_URL}/projects/${projectId}/roads`);
      const data = await response.json();
      setRoads(data);
    } catch (error) {
      console.error('Error loading roads:', error);
    }
  };

  const addRoad = async () => {
    if (!newRoadName.trim()) return;

    try {
      const response = await fetch(`${API_URL}/projects/${projectId}/roads`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: newRoadName }),
      });

      if (response.ok) {
        setNewRoadName('');
        setShowAddRoad(false);
        loadRoads();
      }
    } catch (error) {
      console.error('Error adding road:', error);
    }
  };

  if (!project) return <div>Chargement...</div>;

  return (
    <div className="project-detail">
      <div className="project-header">
        <h1>{project.name}</h1>
        {project.object && <p className="project-object">{project.object}</p>}
        <div className="project-info">
          <span>👤 {project.client?.name}</span>
          <span>🏘️ {project.commune?.name}</span>
        </div>
      </div>

      <div className="roads-section">
        <div className="section-header">
          <h2>Routes ({roads.length})</h2>
          <button onClick={() => setShowAddRoad(true)} className="btn-add">
            ➕ Ajouter Route
          </button>
        </div>

        {showAddRoad && (
          <div className="add-road-form">
            <input
              type="text"
              placeholder="Nom de la route"
              value={newRoadName}
              onChange={(e) => setNewRoadName(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && addRoad()}
            />
            <button onClick={addRoad} className="btn-save">Ajouter</button>
            <button onClick={() => setShowAddRoad(false)} className="btn-cancel">Annuler</button>
          </div>
        )}

        <div className="roads-list">
          {roads.map(road => (
            <div
              key={road.id}
              className="road-item"
              onClick={() => onSelectRoad(road.id, road.name)}
            >
              <span>🛣️ {road.name}</span>
              <span className="arrow">→</span>
            </div>
          ))}
        </div>

        {roads.length === 0 && !showAddRoad && (
          <div className="empty-roads">
            <p>Aucune route définie</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectDetail;
